/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */

import React, { useState, useEffect } from 'react';
//import { withRouter, useLocation, useParams, useNavigate } from 'react-router-dom';
// import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import Link from '@material-ui/core/Link';
import {
  Grid,
  Button,
  Typography,
  colors
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ROUTE from '../../utils';
import {useHistory, useNavigate} from "react-router-dom"; 
import { FormControl, Card, CardContent, CardMedia } from '@mui/material';
import {MainMenu} from '../GetStarted/MainMenu';
import {NavLink} from 'react-router-dom';
import {default as Footer} from '../pages/Footer';
import NavbarLower from '../GetStarted/NavbarLower';
import { ThemeProvider } from 'styled-components';
import { Form, InputGroup, Row,Container,Col} from 'react-bootstrap';
import ChatBot from 'react-simple-chatbot';
const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(2),
    },
    fontFamily: 'Helvetica , sans-serif'
  },

  grid: {
    height: '100%'
  },
  quoteContainer: {
    //[theme.breakpoints.down('md')]: {
      //display: 'none'
      textAlign:'center'
    //}
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.PNG)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 600
  },
  name: {
    //marginTop: theme.spacing(3),
    color: theme.palette.white,
    fontWeight: 500,
    textAlign: 'center'
  },
  bio: {
    // fontWeight: 500,
    color: theme.palette.white,
    fontWeight: 500
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    /*[theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }*/
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0),
    backgroundColor: colors.lime[500],
    color: theme.palette.black,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: colors.lightBlue[300],
      // color: colors.lime[500]
  }
  },

  //Adding styling for the cards
  card: {
    //borderRadius: 100,
    boxShadow: theme.shadows[3],
    marginBottom: theme.spacing(2),
    display: 'flex',
    //backgroundColor:'2px solid #61dafb',
  },
  content: {
    padding: theme.spacing(2),
  },
  title: {
    color:'#000000',
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  description: {
    color: '#000000',
    fontSize: 16,
    fontFamily: 'Helvetica , sans-serif',
  },
}));

//Chat Boot step these are to be fetched from the database.
const steps = [
  {
      id: '0',
      message: 'Dear customer,',
      trigger: '1',
  }, {
      id: '1',

      // This message appears in
      // the bot chat bubble
      message: 'Enter your name for more information',
      trigger: '2'
  }, {
      id: '2',
      user: true,
      trigger: '3',
  }, {
      id: '3',
      message: " hi {previousValue}, how can I help you?",
      trigger: 4
  }, 
  {
    id: '4',
    user: true,
    trigger: 5
  },
  {
    id: '5',
    message: "Based on your input, here are the available matches.",
    trigger: 6
  },
  {
      id: '6',
      options: [
        { value: 0, label: 'Here are the services we offer on the SelfServe Page'},
        { value: 1, label: '1.ATM Card Limit'},
        { value: 2, label: '2.ATM card replacement' },
        { value: 3, label: '3.ATM card blocking' },
        { value: 4, label: '4.PIN Reset' },
        { value: 5, label: '5.Device change request' },
        { value: 6, label: '6.Cheque book request' },
        { value: 7, label: '7.Stop payment request' },
        { value: 8, label: 'To update your account information, Go to the Update form page' },
        {value: 9, label: 'For More enquiries reachout to us on +256800217200'},
      ],
      //user:true,
      end: true
  }
];
const theme = {
  background: '#ffffff',
  headerBgColor: colors.lime[500],
  headerFontSize: '16px',
  botBubbleColor: 'rgb(0,173,238)',
  headerFontColor: 'white',
  botFontColor: 'white',
  userBubbleColor: '#FF5733',
  userFontColor: 'white',
};
// Set some properties of the bot
const config = {
  //botAvatar: "img.png",
  floating: true,
};
export const LandingPage = props => {
  const { history } = props;

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  let navigate= useNavigate();
  const HandleFormPush = () => {
    
    // history.goBack();
    //history.push(ROUTE.form);
    //history.push(ROUTE.getstarted);
    navigate(ROUTE.form);
    //navigate(ROUTE.form);
  };
  //let navigate = useHistory();
  return (
    <>
    <NavbarLower/>

    <Row className={classes.quote}>
        <Col xs={12} md={6} > 

        </Col>

        <Col xs={12} md={6} className={classes.content} > 
            <Card className={classes.card} style={{ borderRadius: '50px' }}>
                    <CardContent className={classes.content}>
                      <Typography className={classes.title}
                          variant="h5"
                          component={NavLink}
                          to='/selfserve'
                          style={{ textDecoration: 'none' }}
                          activeStyle={{ textDecoration: 'none' }}
                        >
                        SelfServe Services
                      </Typography>
                      <Typography variant="h6" className={classes.description}>
                      ATM card replacement, ATM card blocking, ATM Card Limit Enhancement, Pin reset, Device change request, Cheque book request and Stop payment request.
                      </Typography>
                    </CardContent>
                    {/*<CardMedia
                      component="img"
                      //src={previewFrontImage}
                      alt="Front image"
                      //style={{ width: '30%', height: '20%', objectFit: 'fill' }}
                      style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                    />*/}
            </Card>
            <br/>
            
            <Card className={classes.card}  style={{ borderRadius: '70px' }} linkTo="/form">
                    <CardContent className={classes.content}>
                        <Typography className={classes.title}
                          variant="h5"
                          component={NavLink}
                          to='/form'
                          style={{ textDecoration: 'none' }}
                          activeStyle={{ textDecoration: 'none' }}
                        >
                        Customer Information Update Form
                        </Typography>
                      <Typography variant="h6" className={classes.description}>
                        Lets Comply with the Bank of Uganda.
                      </Typography>
                    </CardContent>
            </Card>
            



            {/*<ThemeProvider theme={theme}>
                <ChatBot
                    // This appears as the header
                    // text for the chat bot
                    headerTitle="SelfServe ChatBot"
                    steps={steps}
                    {...config}
 
                />
                  </ThemeProvider>*/}
            <Footer/>
        </Col>
    </Row>
    </>
  );
};

LandingPage.propTypes = {
  history: PropTypes.object
};

export default LandingPage;

